import React, { Suspense } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Spinner from '@divvy-web/skylab.spinner'

import CreditApplicationsDataGrid from './CreditApplicationsDataGrid'
import DashboardFooter from './DashboardFooter'
import DashboardHeader from './DashboardHeader'
import FileUploadStatusProvider from './FileUploadStatusProvider'
import styles from './styles.module.scss'

export const Dashboard = () => {
  const [getClassName] = useNameFormatter('Dashboard')

  return (
    <Suspense fallback={<Spinner fullPage />}>
      <FileUploadStatusProvider>
        <div className={styles[getClassName('')]}>
          <DashboardHeader />
          <CreditApplicationsDataGrid />
          <DashboardFooter />
        </div>
      </FileUploadStatusProvider>
    </Suspense>
  )
}

export default Dashboard
